<script lang="ts" setup>
import { type ToasterProps, Toaster as Sonner } from 'vue-sonner';
import { IconAlertTriangle, IconInfoCircle, IconCircleCheck, IconXboxX, IconLoader, IconX } from '@tabler/icons-vue';
import { cn } from '@ui/lib/utils.js';
import { reactiveOmit } from '@vueuse/core';

const props = defineProps<ToasterProps>();
const delegatedProps = reactiveOmit(props, 'class', 'toastOptions');
</script>

<template>
    <Sonner
        :class="cn('toaster group ', props.class)"
        :toastOptions="{
            unstyled: true,
            classes: {
                toast: 'bg-card-primary rounded p-4 border border-border-default shadow-sm flex gap-2 items-center',
                title: 'text-foreground-primary paragraph-sm font-medium',
                description: 'text-foreground-muted paragraph-sm font-regular',
                actionButton: 'px-2 py-1 rounded bg-surface-secondary text-foreground-on-secondary paragraph-xs',
            },
        }"
        v-bind="delegatedProps"
    >
        <template #success-icon>
            <IconCircleCheck class="size-4" />
        </template>
        <template #info-icon>
            <IconInfoCircle class="size-4" />
        </template>
        <template #warning-icon>
            <IconAlertTriangle class="size-4" />
        </template>
        <template #error-icon>
            <IconXboxX class="size-4" />
        </template>
        <template #loading-icon>
            <IconLoader class="size-4 animate-spin" />
        </template>
        <template #close-icon>
            <IconX class="size-4" />
        </template>
    </Sonner>
</template>
